import React from "react";

export const Eros = () => {
  return (
    <div>
      <div
        id={"eros"}
        style={{
          frameborder: "0",
          width: "100%",
          height: "470px",
        }}
      ></div>
    </div>
  );
};

